<template>
  <crm-side-panel @handleClose="handleDialogClose('thisDialog')" :title="titleFullName">
    <div class="side-panel-content busi-detail-content custom-details">
      <div class="side-panel-buttons">
        <crm-button
          v-if="
            productManageAuth &&
            productManageAuth.productLineEnabled.toggleStatus &&
            productManageAuth.productLineDisabled.toggleStatus
          "
          :size="'mini'"
          :buttonType="'danger'"
          :text="
            productDetail.bfmStatus === 0 && productDetail.status === 0 ? '停用' : '启用'
          "
          @click="handleChangeSataus()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 头部信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">产品线编号</p>
            <p class="info-detail">
              {{ productDetail.code }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">所属产品大类</p>
            <p class="info-detail">
              {{ productDetail.typeName }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">状态</p>
            <p class="info-detail">
              {{
                productDetail.bfmStatus === 0 && productDetail.status === 0
                  ? "已启用"
                  : "已停用"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="side-panel-tabs">
        <el-tabs v-model="tabActiveName" @tab-click="handleTabClick" v-loading="loading">
          <!-- 详情信息 -->
          <el-tab-pane
            label="详情信息"
            name="details"
            v-if="getModuleAuth('productLineDetail')"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'编辑说明'"
                class="fr mb10"
                @click="handleDialogShow('updateRemark')"
                v-if="getModuleAuth('productLineUpdateRemark')"
              >
              </crm-button>
            </div>
            <pane-info
              @toDetail="toDetail"
              :common="productDetail"
              :detail="productDetail"
            ></pane-info>
          </el-tab-pane>
          <!-- 管理员 -->
          <el-tab-pane
            label="管理员"
            name="manager"
            v-if="getModuleAuth('productLineQueryAdminList')"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'新增'"
                class="fr mb10"
                @click="handleDialogShow('manager')"
                v-if="getModuleAuth('productLineAdminAddBtn')"
              >
              </crm-button>
            </div>
            <el-table :data="adminList.results" height="100%" style="width: 100%">
              <el-table-column prop="loginId" align="center" label="账号">
              </el-table-column>
              <el-table-column prop="userName" align="center" label="姓名">
              </el-table-column>
              <el-table-column prop="teamName" align="center" width="350" label="团队">
              </el-table-column>
              <el-table-column prop="roleName" align="center" label="角色">
              </el-table-column>
              <el-table-column prop="gmtModifiedStr" align="center" label="更新时间">
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="handleDeleteAdmin(scope)"
                    v-if="getModuleAuth('productLineAdminDel')"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleManagerSizeChange"
                @current-change="handleManagerCurrentChange"
                :current-page="adminList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="adminList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="adminList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 商机管理 -->
          <el-tab-pane
            label="商机阶段"
            name="businessManage"
            v-if="getModuleAuth('productLineQueryBusinessTypeList')"
          >
            <el-table :data="businessManageList" height="100%" style="width: 100%">
              <el-table-column prop="businessTypeName" align="center" label="商机阶段">
              </el-table-column>
              <el-table-column prop="mobile" align="center" label="开放操作">
                <template slot-scope="scope">
                  <span v-if="scope.row.operNameList.length === 0"> - </span>
                  <span
                    v-else
                    v-for="(i, key) in scope.row.operNameList"
                    :key="key"
                    class="label"
                  >
                    {{ i }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="stageTip" align="center" label="阶段提示">
                <template slot-scope="scope">
                  <span>{{ scope.row.stageTip || " - " }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="modifier" align="center" label="更新人">
              </el-table-column>
              <el-table-column
                prop="gmtModifiedStr"
                align="center"
                width="150"
                label="更新时间"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="getModuleAuth('productLineBusinessTypeConfig')"
                    @click="handleDialogShow('businessManage', scope)"
                    type="text"
                    size="small"
                  >
                    配置
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 附件 -->
          <el-tab-pane
            label="附件"
            name="file"
            v-if="getModuleAuth('productLineQueryFileList')"
          >
            <el-upload
              class="mb10 text-right"
              action="string"
              accept="image/jpeg,image/png,image/bmp,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/x-rar-compressed,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,.txt"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :http-request="handleUploadFile"
            >
              <crm-button
                v-if="getModuleAuth('productLineFileUpload')"
                :buttonType="'secondary'"
                :size="'mini'"
                :text="'上传附件'"
              >
                <el-tooltip
                  content="图片文件单个不能超过5M；其他文件单个不能超过50M"
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <span class="el-icon-question" style="font-size: 16px"></span>
                </el-tooltip>
              </crm-button>
            </el-upload>
            <el-table
              :data="fileData.results"
              class="tab-table-item"
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                show-overflow-tooltip
                prop="fileUrl"
                label="附件"
                align="center"
              >
                <template slot-scope="scope">
                  <a
                    v-if="getModuleAuth('productLinePreview') && scope.row.previewUrl"
                    href="javascript:;"
                    @click="getFildUrl(scope.row)"
                  >
                    <i class="know-doc-top" v-if="scope.row.isTop === 1">置顶</i>
                    {{ scope.row.fileName }}
                  </a>
                  <span v-else>{{ scope.row.fileName || "暂无数据" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="creatorName"
                label="操作人"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                label="上传时间"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column width="250" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      getModuleAuth('productLineFileTop') &&
                      getModuleAuth('productLineCancelFileTop')
                    "
                    type="text"
                    size="small"
                    @click="handleTopFile(scope)"
                  >
                    {{ scope.row.isTop === 1 ? "取消置顶" : "置顶" }}
                  </el-button>
                  <el-button
                    v-if="getModuleAuth('productLineFileDel')"
                    @click="handleDeleteFile(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>

                  <a
                    v-if="getModuleAuth('productLineFileDownload') && scope.row.fileUrl"
                    :href="scope.row.fileUrl"
                  >
                    下载
                  </a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <p class="pageination-tip">
                说明：单个图片文件最大支持 5MB，其他文件最大支持 50MB，上传请耐心等待
              </p>
              <el-pagination
                @size-change="handleFileSizeChange"
                @current-change="handleFileCurrentChange"
                :current-page="fileData.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="fileData.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="fileData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 编辑说明弹窗 -->
    <el-dialog
      title="产品线说明"
      width="50%"
      :visible.sync="updateRemarkVisible"
      append-to-body
      @close="handleDialogClose('updateRemark')"
    >
      <el-input
        type="textarea"
        placeholder="请输入产品说明内容（100 字以内）"
        v-model="productDetailEdit.remark"
        rows="5"
        maxlength="100"
        show-word-limit
      >
      </el-input>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('updateRemark', true)"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleChangeUpdateRemark()"></crm-button>
      </div>
    </el-dialog>

    <!-- 新增管理员 -->
    <el-dialog
      title="新增管理员"
      width="20%"
      :visible.sync="adminDialogVisible"
      append-to-body
      @close="handleDialogClose('manager')"
    >
      <el-select
        filterable
        v-model="searchAdminKey"
        :placeholder="envCrm ? '请输入OA账号或姓名' : '请输入手机号或姓名'"
      >
        <el-option
          v-for="item in allAdminList"
          :label="`${item.userName} - ${item.loginId}`"
          :value="item.code"
          :key="item.code"
          :disabled="item.disabled"
        >
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('manager', true)"
        >
        </crm-button>
        <crm-button
          :text="'确定'"
          :disabled="!searchAdminKey"
          @click="handleChangeAdmin()"
        ></crm-button>
      </div>
    </el-dialog>

    <!-- 商机阶段 -->
    <el-dialog
      title="商机规则配置"
      width="50%"
      :visible.sync="businessManageVisible"
      append-to-body
      @close="handleDialogClose('businessManage', true)"
    >
      <el-form label-width="80px" :model="busiTypeTipDetail">
        <el-form-item label="商机阶段">
          <el-input
            v-model="busiTypeTipDetail.businessTypeName"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="开放操作">
          <el-checkbox-group v-model="busiTypeTipDetail.operation">
            <el-checkbox
              v-for="i in busiTypeTipDetail.operationList"
              :key="i.id"
              name="type"
              :label="i.id"
              >{{ i.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="阶段提示">
          <el-input
            type="textarea"
            placeholder="请输入阶段提示内容（100 字以内）"
            v-model="busiTypeTipDetail.stageTip"
            rows="5"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('businessManage', true)"
        >
        </crm-button>
        <crm-button
          :text="'确定'"
          :disabled="!busiTypeTipDetail.businessTypeName"
          @click="handleChangeBusiType()"
        ></crm-button>
      </div>
    </el-dialog>
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
  </crm-side-panel>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { formatTimeShow } from "@/scripts/utils";
import { uploadFileVerify } from "@/scripts/reg";
import service from "~api/backstage";

import BusiDetail from "~component/business/busiopportunity/busiDetail.vue";
import CompactDetail from "~component/business/compact/detail.vue";
import AddUpdate from "~component/business/compact/AddUpdate.vue";
import AddProject from "~component/business/project/addProject.vue";
import AddCompact from "~component/business/compact/AddCompact.vue";
import EditCustom from "~component/business/custom/editCustom";
import CrmSidePanel from "~component/base/crmSidePanel.vue";
import CrmButton from "@/components/base/crmButton";
import AddBusi from "~component/business/busiopportunity/addBusi";
import PaneInfo from "./pane-info.vue";

export default {
  components: {
    BusiDetail,
    CompactDetail,
    AddUpdate,
    AddCompact,
    EditCustom,
    CrmSidePanel,
    CrmButton,
    AddBusi,
    PaneInfo,
    AddProject,
    ClueDetail() {
      return import("@/components/business/clue/detail.vue");
    },
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  filters: {
    formatTimeShow,
    orgStateFilter(val) {
      let result = "";
      if (val === 1) result = "待审核";
      if (val === 2) result = "审核通过";
      if (val === 3) result = "驳回";
      return result;
    },
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    authEdit: [Number, Boolean],
    authDelete: [Number, Boolean],
    authBusi: [Number, Boolean],
    sourcePart: String,
  },
  data() {
    return {
      // 是否是对内系统 env_crm__ true 默认是
      envCrm: null,
      row: {},
      imagePreview: {
        showImage: false,
        url: "",
      },
      loading: false,
      tabActiveName: "details",
      adminList: {
        pageNumber: 1,
        pageSize: 10,
        results: [{}],
        totalCount: 1,
        totalPages: 1,
      },
      // 新增管理员
      adminDialogVisible: false,
      allAdminList: [],
      searchAdminKey: "",
      // 附件
      fileData: {
        pageNumber: 1,
        pageSize: 10,
        results: [{}],
        totalCount: 1,
        totalPages: 1,
      },
      // 商机管理
      businessManageList: [],
      // 商机详情
      busiDetailVisible: false,
      detailId: "",
      nextButtonState: false,
      // 新增商机
      addUpdateBusiVisible: false,
      isAdd: false,
      busiOpportunityDetail: {},
      isAddBusiVisible: false,
      // 合同详情
      compactDetailId: "",
      compactDetailVisible: false,
      clickFrom: "",
      addUpdateVisible: false,
      detail: {},
      productDetail: {},
      productDetailEdit: {
        remark: "",
      },
      // 商机阶段配置详情
      busiTypeTipDetail: {},
      updateRemarkVisible: false,
      businessManageVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      customAuth: "authority/customAuth",
      productManageAuth: "authority/productManageAuth",
      userInfo: "authority/userInfo",
    }),
    titleFullName() {
      const { name } = this.productDetail;
      return name;
    },
  },
  watch: {
    id(val) {
      this.tabActiveName = "details";
      if (val) {
        this.updatePanel();
      }
    },
  },
  mounted() {
    this.envCrm = cookie.get("_env_crm__") !== "false";
  },
  methods: {
    ...mapActions({}),
    toDetail(id) {
      this.clueVisible = true;
      this.clueId = id;
    },
    handleChangeSataus() {
      const params = {
        id: this.productDetail.id,
        status: this.productDetail.status,
      };
      // 启用状态 需要停用 提示框
      if (this.productDetail.bfmStatus === 0 && this.productDetail.status === 0) {
        this.$confirm(
          "停用后，该产品线将不可再被新的商机、合同关联，是否继续？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            service.disabledProductLine(params).then((res) => {
              this.apiGetDetail();
              this.$emit("saveEditProduct");
            });
          })
          .catch(() => {});
      } else {
        // 停用状态 需要启用
        service.enableProductLine(params).then((res) => {
          this.apiGetDetail();
          this.$emit("saveEditProduct");
        });
      }
    },
    getModuleAuth(authName) {
      return this.productManageAuth[authName]?.toggleStatus;
    },
    // 编辑说明
    handleChangeUpdateRemark() {
      service
        .updateRemark({
          id: this.productDetail.id,
          remark: this.productDetailEdit.remark,
        })
        .then((res) => {
          this.updateRemarkVisible = false;
          this.productDetailEdit.remark = "";
          this.apiGetDetail();
          this.$emit("saveEditProduct");
        });
    },
    handleUpdateRemark(data) {
      this.productDetailEdit = {
        remark: "",
      };
      this.updateRemarkVisible = true;
      this.productDetailEdit.remark = data.remark;
    },
    // 新增-管理员
    handleChangeAdmin() {
      return service
        .addAdmin({
          productLineUid: this.productDetail.id,
          userId: this.searchAdminKey,
        })
        .then((res) => {
          this.adminDialogVisible = false;
          this.searchAdminKey = "";
          this.getAdminList();
          this.$emit("saveEditProduct");
        });
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    handleFileSizeChange(val) {
      this.fileData.pageSize = val;
      this.fileData.pageNumber = 1;
      this.updatePanel();
    },
    handleManagerSizeChange(val) {
      this.adminList.pageSize = val;
      this.adminList.pageNumber = 1;
      this.updatePanel();
    },
    handleFileCurrentChange(val) {
      this.fileData.pageNumber = val;
      this.updatePanel();
    },
    handleManagerCurrentChange(val) {
      this.adminList.pageNumber = val;
      this.updatePanel();
    },
    handleTabClick() {
      this.updatePanel();
    },
    // tab页数据获取
    updatePanel() {
      let p = null;
      this.loading = true;
      switch (this.tabActiveName) {
        case "details":
          p = this.apiGetDetail();
          break;
        case "manager":
          this.adminList.pageSize = 10;
          this.adminList.pageNumber = 1;
          p = this.getAdminList();
          break;
        case "file":
          this.fileData.pageSize = 10;
          this.fileData.pageNumber = 1;
          p = this.apiGetFileList({ pageNumber: 1 });
          break;
        case "businessManage":
          p = this.apiGetBusinessManage();
          break;
        default:
          p = Promise.reject();
          break;
      }
      p.finally(() => {
        this.loading = false;
      });
    },
    // tab页数据获取-详情
    apiGetDetail() {
      return service
        .queryProductDetail({
          id: this.id,
        })
        .then((res) => {
          this.productDetail = res.data;
        })
        .catch((err) => {
          console.log(err, "err");
          this.handleDialogClose("thisDialog");
        });
    },
    // tab页数据获取-商机管理
    apiGetBusinessManage() {
      return service
        .queryBusinessTypeList({
          productLineUid: this.id,
        })
        .then((res) => {
          this.businessManageList = res.data.data;
        });
    },

    // 显示弹窗
    // 根据type，也就是tab名判断属于哪个tab的弹窗
    // 根据scope有无，判断新增还是编辑
    handleDialogShow(type, scope) {
      switch (type) {
        case "updateRemark":
          this.handleUpdateRemark(this.productDetail);
          break;
        case "manager":
          this.handleOpenManager(scope);
          break;
        case "businessManage":
          this.handleOpenBusiManage(scope);
          break;
        default:
          break;
      }
    },
    // 显示弹窗-管理员
    handleOpenManager(scope) {
      this.getAllAdminList();
      this.adminDialogVisible = true;
    },
    getAdminList() {
      return service
        .queryAdminList({
          productLineUid: this.productDetail.id,
          pageNumber: this.adminList.pageNumber,
          pageSize: this.adminList.pageSize,
        })
        .then((res) => {
          this.adminList = res.data;
        });
    },
    getAllAdminList() {
      this.searchAdminKey = "";
      return service
        .queryTeamUser({
          userName: this.searchAdminKey,
          loginId: this.searchAdminKey,
        })
        .then((res) => {
          this.adminList.results.forEach((item) => {
            res.data.data.forEach((i) => {
              if (i.code === item.userCode) {
                i.disabled = true;
              }
            });
          });
          this.allAdminList = res.data.data;
        });
    },
    handleDeleteAdmin(scope) {
      this.$confirm("是否确认删除该管理员？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        service
          .deleteAdmin({ id: scope.row.id })
          .then(() => {
            this.getAdminList();
            this.apiGetDetail();
            this.$emit("saveEditProduct");

            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {});
      });
    },
    // 显示弹窗-商机
    handleOpenBusiManage(scope) {
      this.businessManageVisible = true;
      this.getBusTypeDetail(scope);
    },
    getBusTypeDetail(scope) {
      this.busiTypeTipDetail = {};
      return service.queryBusinessTypeOperDetail({ id: scope.row.id }).then((res) => {
        // 合并值
        this.busiTypeTipDetail = Object.assign({}, res.data);
        this.busiTypeTipDetail.businessTypeName = scope.row.businessTypeName;
        this.busiTypeTipDetail.stageTip = scope.row.stageTip;
        this.busiTypeTipDetail.operation = scope.row.operation;
        this.busiTypeTipDetail.operationList = res.data.businessTypeOperList;
      });
    },
    handleChangeBusiType() {
      return service
        .configBusinessType({
          id: this.busiTypeTipDetail.id,
          stageTip: this.busiTypeTipDetail.stageTip,
          operation: this.busiTypeTipDetail.operation,
        })
        .then((res) => {
          this.businessManageVisible = false;
          this.apiGetBusinessManage();
          this.$emit("saveEditProduct");
        });
    },
    // 关闭弹窗
    // 根据isAdd判断新增弹窗还是编辑弹窗
    handleDialogClose(type, isAdd) {
      switch (type) {
        case "updateRemark":
          this.updateRemarkVisible = false;
          break;
        case "thisDialog":
          this.$emit("closeProductDetail");
          break;
        case "businessManage":
          this.businessManageVisible = false;
          break;
        case "manager":
          this.adminDialogVisible = false;
          break;
        default:
          break;
      }
    },
    // 附件表格-上传校验
    async beforeUpload(file) {
      /* eslint-disable */
      let isLt2M;
      if (file.type.includes("image")) {
        isLt2M = file.size / 1024 / 1024 < 5;
      } else {
        isLt2M = file.size / 1024 / 1024 < 50;
      }
      if (!isLt2M) {
        this.$message.error("单个图片文件最大支持 5MB，其他文件最大支持 50MB!");
        return Promise.reject();
      }
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 附件表格-上传
    handleUploadFile(item) {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在上传中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append("file", item.file);
      params.append("fileName", item.file.name);
      params.append("bizUid", this.id);
      return service
        .fileUpload({
          params,
          config: { "Content-Type": "multipart/form-data", timeout: 100000 },
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          this.apiGetFileList();
          this.$emit("saveEditProduct");
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    // 附件表格-删除
    handleDeleteFile(scope) {
      this.$confirm("是否确认删除该附件？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() =>
          service
            .deleteFile({
              id: scope.row.id,
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.apiGetFileList();
              this.$emit("saveEditProduct");
            })
        )
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 附件列表
    apiGetFileList(page) {
      this.fileData.pageNumber = page?.pageNumber;
      return service
        .queryFileList({
          bizUid: this.id,
          pageNumber: page?.pageNumber || this.fileData.pageNumber,
          pageSize: this.fileData.pageSize,
        })
        .then((res) => {
          this.fileData = res.data;
        });
    },
    // 置顶 取消置顶
    handleTopFile(scope) {
      if (scope.row.isTop === 1) {
        service
          .cancelFileTop({
            id: scope.row.id,
          })
          .then((res) => {
            this.apiGetFileList({ pageNumber: 1 });
          });
      } else {
        service
          .fileTop({
            id: scope.row.id,
          })
          .then((res) => {
            this.apiGetFileList({ pageNumber: 1 });
          });
      }
    },
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.custom-details {
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    margin-top: -6px;
    margin-left: -13px;
    .button-group {
      position: absolute;
      right: 40px;
      top: 6px;
    }
    .icon-detail-close {
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
    }
  }
  header {
    line-height: 32px;
  }
  section {
    margin: 10px 0;
  }
  article {
    flex: 1;
    display: flex;
    .el-tabs__header {
      background-color: #f4f4f4;
      margin-left: -13px;
      padding-left: 13px;
    }
    .el-tabs--top {
      flex: 1;
      display: flex;
      flex-direction: column;
      .el-tabs__content {
        overflow: auto;
        display: flex;
        flex: 1;
        .el-tab-pane {
          width: 100%;
          height: 100px;
        }
      }
    }
  }
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.pagination-wrap {
  margin-top: 10px;
  text-align: center;
}
.label {
  border: 1px solid #ebeef5;
  background-color: #f0f3ff;
  padding: 3px 5px;
  border-radius: 4px;
  margin: 0 3px;
}
.pageination {
  overflow: hidden;
}
.pageination-tip {
  float: left;
  margin: 20px;
}
.know-doc-top {
  display: inline-block;
  width: 40px;
  height: 20px;
  background: rgba(255, 120, 120, 1);
  border-radius: 12px;
  font-size: 12px;
  font-family: "PingFangSC-Regular,PingFang SC";
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  font-style: normal;
}
</style>
